import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { token } from "@atlaskit/tokens";

import { useFilteredAndSortedRoadmapFeatures } from "../context/hooks";

import { Card } from "./card.tsx";
import { SelectedFeatureModal } from "./selected-feature-modal.tsx";

export const Cards = () => {
    const intl = useIntl();
    const features = useFilteredAndSortedRoadmapFeatures();
    if (!features) {
        return null;
    }

    return (
        <>
            <div css={cardsCss}>
                {features.length === 0 ? (
                    <div css={noResultsCss}>
                        <p>
                            {intl.formatMessage({
                                id: "roadmapFeatures.noResults",
                                defaultMessage: "No Results"
                            })}
                        </p>
                    </div>
                ) : (
                    features.map((data) => <Card key={data.slug} data={data} />)
                )}
            </div>
            <SelectedFeatureModal />
        </>
    );
};

const cardsCss = css({
    display: "flex",
    flexDirection: "column",
    gap: token("space.300")
});

const noResultsCss = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: token("space.600"),
    color: token("color.text.subtle")
});
